import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c91fbfb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "layer-title"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "p-1" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "height-full flex-between"
}
const _hoisted_8 = { class: "p-1 flex flex-between" }
const _hoisted_9 = { class: "fetch-time" }
const _hoisted_10 = { class: "p-1 flex flex-between" }
const _hoisted_11 = { class: "field-name top" }
const _hoisted_12 = { class: "mx-1" }
const _hoisted_13 = { class: "unit" }

import { onMounted, onUnmounted, watch, ref, computed, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { useIntervalFn } from '@vueuse/core'
import moment from 'moment'
import { OlMap, GpvLayerName } from '@/lib/olmap'
import { useInitDataStore } from '@/stores/initDataStore'
import { usePresentStore } from '@/stores/presentStore'
import { useGpvStore } from '@/stores/gpvStore'
import { StationListItem, StationGeometry, StationList } from '@/models/InitData'
import { camelCase } from 'lodash'
import { displayPresentLevel, getFetchTime } from '@/lib/field'
import { useGlobalStore } from '@/stores/globalStore'
import { useDojouMeshStore } from '@/stores/dojouMeshStore'
import $ from 'jquery'

type Props = {
  field?: string
  renderLayer?: GpvLayerName
  mapType?: string
  stations?: StationList
  area?: {
    zoom: number
    latitude: number
    longitude: number
  }
}


export default /*#__PURE__*/_defineComponent({
  props: {
    field: null,
    renderLayer: null,
    mapType: null,
    stations: null,
    area: null
  },
  emits: ['mouseonStation'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  field?: string
  renderLayer?: GpvLayerName
  mapType?: string
  stations?: StationList
  area?: {
    zoom: number
    latitude: number
    longitude: number
  }
}


const LAYER_TITLES = {
  radar_rain: '雨雲レーダー',
  radar_disaster: '土砂災害危険度',
  radar_soilwater: '土壌雨量指数',
  hazard: 'ハザードマップ',
  hazard_0: '洪水浸水想定区域（想定最大規模）',
  hazard_1: '洪水浸水想定区域（計画規模（現在の凡例））',
  hazard_2: '高潮浸水想定区域',
  hazard_3: '津波浸水想定',
}
const globalStore = useGlobalStore()
const dojouMeshStore = useDojouMeshStore()
let map: OlMap
const FETCH_INTERVAL = 60 * 1000 // 1分

const initDataStore = useInitDataStore()
const presentStore = usePresentStore()
const gpvStore = useGpvStore()
const router = useRouter()



const hoverStation = ref<StationListItem | undefined>()
const fixPopup = ref(false)
const now = ref(moment().format('HHmm'))

const mapInfo = computed(() => {
  if (props.mapType === 'summary') {
    return initDataStore.definitionInfoTop().items[0].args.mapInfo
  } else {
    return initDataStore.mapInfo
  }
})

const mapPositionData = computed(() => ({
  defaultLimitLeftUpLatitude: mapInfo.value.rangeLimit.leftUp.latitude,
  defaultLimitLeftUpLongitude: mapInfo.value.rangeLimit.leftUp.longitude,
  defaultLimitRightDownLatitude: mapInfo.value.rangeLimit.rightDown.latitude,
  defaultLimitRightDownLongitude: mapInfo.value.rangeLimit.rightDown.longitude,
  defaultLimitZoomDefault: mapInfo.value.position.zoom.default,
  defaultLimitZoomMax: mapInfo.value.position.zoom.max,
  defaultLimitZoomMin: mapInfo.value.position.zoom.min,
  defaultLatitude: mapInfo.value.position.latitude,
  defaultLongitude: mapInfo.value.position.longitude,
}))

const fieldInfo = computed(() => {
  return initDataStore.initData.fieldList[camelCase(props.field)]
})
const stations = computed(() => {
  if (props.mapType === 'summary') {
    return props.stations
  }

  if (props.field === 'camera') {
    return initDataStore.initData.cameraList
  } else {
    return initDataStore.initData.stationList
  }
})

const topGraphical2Def = computed(() => {
  return initDataStore.initData.definitionInfo.top.graphical.topGraphical1
})

const topGraphical1Icons = computed(() => {
  const definition = topGraphical2Def.value

  if (definition === undefined) {
    return []
  }

  const { left, right } = definition
  const results = [] as { field: string; station: StationGeometry }[]
  const stationList = initDataStore.initData.stationList
  const panelInfos = [...left.top, ...left.bottom, ...right.top, ...right.bottom]

  panelInfos.forEach(panelInfo => {
    if (panelInfo.panelType === 'map_image_type1') {
      return
    }

    const { iconFieldId, stationId } = panelInfo.args

    const station = stationList.find(s => s.stationId === stationId)

    if (station === undefined) {
      return
    }

    results.push({
      field: iconFieldId || 'moveRainMin10',
      station,
    })
  })

  return results
})

const setStations = () => {
  const definition = topGraphical2Def.value

  if (!map) {
    return
  }

  // 地図パネル表示がある場合はパネル情報からアイコンを生成
  if (definition !== undefined) {
    topGraphical1Icons.value.forEach(({ field, station }) => {
      const icon = map.getIconUrl(station, field)

      map.setStation(icon, station)
    })

    // カメラ局配置
    stations.value?.forEach(s => {
      const icon = '/cdn_images/image/map/camera_icon.png'

      map.setStation(icon, s)
    })

    return
  }

  if (props.mapType === 'summary' && stations.value && props.field) {
    return map.setStations(stations.value, props.field)
  }

  if (props.field === 'camera') {
    map.setStations(initDataStore.initData.cameraList, props.field)
  } else if (props.field) {
    map.setStations(initDataStore.initData.stationList, props.field)
  }
}

const setMapTime = async () => {
  hoverStation.value = undefined

  if (props.renderLayer === undefined) {
    return
  }

  if (!gpvStore.dojou) {
    return
  }

  if (!map) {
    return
  }

  if (props.renderLayer === 'radar_soilwater') {
    $('.icons-bot').show()
    gpvStore.setBaseTime(gpvStore.dojou.baseTime)
    gpvStore.setForcastTime(gpvStore.dojou.forecastTimes[0])
    const params = {
      baseTime: gpvStore.baseTime,
      forecastTime: gpvStore.forecastTime,
      area: '',
    }
    await dojouMeshStore.fetch(params)

    map.setDojouTexts()
  }

  map.setGpvTime(gpvStore.baseTime, gpvStore.forecastTime)
  map.setVisibleGpvLayer(props.renderLayer)
}

watch(() => initDataStore.initData, setStations)
watch(
  () => props.field,
  (current, before) => {
    setStations()

    if (!globalStore.top.showPopup && [current, before].includes('camera')) {
      nextTick().then(() => {
        map.setPopups(stations.value)
      })
    }
  }
)
watch(() => props.renderLayer, setMapTime, { immediate: true })
watch(() => gpvStore.forecastTime, setMapTime, { immediate: true })
watch(() => presentStore.present, setStations)

const layerTitle = computed(() => {
  let title = LAYER_TITLES[props.renderLayer as keyof typeof LAYER_TITLES]

  if (props.renderLayer === 'radar_soilwater') {
    const time = moment(gpvStore.dojou.baseTime).format('HH:mm')
    title += `(${time})`
  }

  return title
})

const mapPanelAvailable = computed(() => !!initDataStore.initData.definitionInfo.top.graphical.topGraphical1)

const displayLevel = (station: StationGeometry) => {
  let field = camelCase(props.field)

  return displayPresentLevel(
    presentStore.present,
    field,
    station as unknown as StationListItem,
    initDataStore.initData.fieldList
  )
}

const fetchTime = (station: StationGeometry) => {
  const time = getFetchTime(presentStore.present, station)

  if (!time) {
    return ''
  }

  return moment(time).format('HH:mm')
}

const mapId = `map${new Date().getTime()}`

watch(
  () => props.area,
  () => {
    if (props.area) {
      map.setPosition(props.area.longitude, props.area.latitude, props.area.zoom)
    }
  }
)

watch(
  () => globalStore.top.showPopup,
  show => {
    if (show) {
      map.showPopups()
    } else {
      map.hidePopups()
    }
  }
)

const moveStationDetail = (station: StationListItem) => {
  if (station.link) {
    open(station.link, '_blank')
  } else {
    if (props.field == 'water_level') {
      router.push(`/water_detail/${station.stationId}`)
    } else if (props.field?.includes('rain')) {
      router.push(`/rain_detail/${station.stationId}`)
    }
  }
}

const handleResize = () => {
  setTimeout(() => {
    map?.map?.updateSize()
  }, 0)
}

onUnmounted(async () => {
  window.removeEventListener('resize', handleResize)
})

onMounted(async () => {
  map = new OlMap()
  const mapSource = initDataStore.initData.systemInfo.mapInfo.mapSource
  map.init(mapId, mapPositionData.value, mapSource)
  map.setPopups(stations.value)
  setMapTime()

  map.onIconHover((station?: StationListItem) => {
    if (props.mapType === 'summary') {
      return
    }

    if (globalStore.top.showPopup) {
      return
    }

    if (fixPopup.value) {
      return
    }

    if (mapPanelAvailable.value) {
      const stationId = station?.stationId

      if (map.map === undefined) {
        return
      }

      if (station) {
        if (station?.fieldId?.includes('camera')) {
          map.showPopup(station)
        } else {
          map.map.getViewport().style.cursor = 'pointer'
        }
      } else {
        hoverStation.value = undefined
        map.hidePopups()
        map.map.getViewport().style.cursor = ''
      }
      emit('mouseonStation', stationId)

      return
    }

    if (station) {
      hoverStation.value = station
      map.showPopup(station)
    } else {
      hoverStation.value = undefined
      map.hidePopups()
    }
  })

  map.onIconClick((station?: StationListItem) => {
    if (station?.stationId) {
      // 地図パネル表示がある場合は詳細に遷移
      if (mapPanelAvailable.value) {
        const field = station.fieldId

        if (field.includes('move_wd_min_10')) {
          router.push(`/weather_detail/${station.stationId}`)
        } else if (field.includes('water_level')) {
          router.push(`/water_detail/${station.stationId}`)
        } else if (field.includes('camera')) {
          // カメラ局は何もしない
          return
        } else {
          router.push(`/rain_detail/${station.stationId}`)
        }
      }

      if (!hoverStation.value) {
        hoverStation.value = station
      }

      if (props.field === 'camera' || globalStore.isSP) {
        hoverStation.value = station
        map.showPopup(station)
        fixPopup.value = true
        return
      }

      moveStationDetail(station)
    } else {
      if (!globalStore.top.showPopup) {
        hoverStation.value = station
        map.hidePopups()
        fixPopup.value = false
      }
    }
  })

  setStations()

  if (globalStore.top.showPopup) {
    map.showPopups()
  }

  setInterval(() => {
    props.renderLayer && setMapTime()
  }, FETCH_INTERVAL)

  window.addEventListener('resize', handleResize)

  useIntervalFn(() => {
    now.value = moment().format('HHmm')
  }, 1000)
})

const hidePopups = () => {
  map.hidePopups()
}

const highlightIcon = (stationId: string) => {
  map.highlightIcon(stationId)
}

expose({ hidePopups, highlightIcon })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: mapId,
    style: {"width":"100%","height":"100%"}
  }, [
    (_unref(layerTitle))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(layerTitle)), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stations), (station) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: station.stationId,
        class: _normalizeClass([`${__props.field} ${station.fieldId.includes('camera') && 'camera'}`, "ol-popup"]),
        id: `popup-${station.stationId}`
      }, [
        _createElementVNode("div", {
          onClick: ($event: any) => (moveStationDetail(station)),
          class: "popup-content"
        }, [
          (__props.field === 'camera' || station.fieldId.includes('camera'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, _toDisplayString(station.name), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: `/camera/${station.stationId}/now.jpg?${now.value}`,
                    style: {"width":"100%"}
                  }, null, 8, _hoisted_6)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(station.name), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(fetchTime(station)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, _toDisplayString(_unref(fieldInfo)?.name), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(displayLevel(station)), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(fieldInfo)?.unit), 1)
                  ])
                ])
              ]))
        ], 8, _hoisted_3)
      ], 10, _hoisted_2)), [
        [_vShow, __props.mapType !== 'summary']
      ])
    }), 128))
  ]))
}
}

})